import { SelectItem } from '@/components/select/selectBoxTypes';

type SingleSelectionValue<T extends SelectItem> = T | string | null;

export const getInitialSingleSelection = <T extends SelectItem>(
  value: SingleSelectionValue<T>,
): T | null => (typeof value === 'string' ? null : value);

export const resolveSingleSelection = <T extends SelectItem>(
  items: T[],
  value: SingleSelectionValue<T>,
): T | null => {
  if (value === null) {
    return null;
  }

  if (typeof value === 'string') {
    return items.find((item) => item.id === value) ?? null;
  }

  return items.find((item) => item.id === value.id) ?? value;
};
